import { render, staticRenderFns } from "./ProfileEditAvatar.vue?vue&type=template&id=7239129b&scoped=true"
import script from "./ProfileEditAvatar.vue?vue&type=script&lang=js"
export * from "./ProfileEditAvatar.vue?vue&type=script&lang=js"
import style0 from "./ProfileEditAvatar.vue?vue&type=style&index=0&id=7239129b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7239129b",
  null
  
)

export default component.exports